import template from './billable_link-directive.tpl.html';

/**
 * @ngdoc directive
 * @name billing.position_links.directive:position_links
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example <billable-link billable=""></billable_link>
 *
 */
angular
    .module('festzelt-os.billing.position_links')
    .directive('billableLink', BillableLinkDirective);

function BillableLinkDirective() {
    return {
        restrict: 'E',
        scope: {},
        templateUrl: template,
        replace: false,
        controllerAs: 'vm',
        controller: [
            '$state',
            '$scope',
            '$uibModal',
            'Rsvp',
            'SweetAlert',
            BillableLinkDirectiveController
        ],
        bindToController: {
            billable: '='
        }
    };
}

function BillableLinkDirectiveController($state, $scope, $uibModal, Rsvp, SweetAlert) {
    var vm = this;

    vm.label = '';
    vm.route = '';
    vm.route_params = '';
    vm.custom_action = null;

    vm.show = false;
    vm.doClickAction = doClickAction;

    init();

    function init() {
        updateBillableInformation();
        initWatchers();
    }

    function initWatchers() {
        $scope.$watch('vm.billable', function (newVal) {
            vm.billable = newVal;
            updateBillableInformation();
        });
    }

    function updateBillableInformation() {
        if (typeof vm.billable === 'undefined') {
            vm.label = '';
            vm.route = '';
            vm.route_params = {};
            vm.show = false;
            vm.custom_action = null;
            return;
        }

        switch (vm.billable.type) {
            case 'seatplan_element':
                vm.label = 'Seatplan Element ' + vm.billable.label + ' on guestlist ' + vm.billable.guestlist_name;
                vm.route = 'app.guestlists.rsvps.seats';
                vm.route_params = {
                    gid: vm.billable.guestlist_id,
                    rsvpId: vm.billable.id
                };
                vm.show = true;
                break;
            case 'rsvp':
                vm.label = 'Rsvp of ' + vm.billable.label + '  on ' + vm.billable.guestlist_name;
                vm.custom_action = function () {
                    console.log('do nothing');
                };
                vm.show = true;
                break;
            case 'contact':
                vm.label = 'Contact ' + vm.billable.label;
                vm.route = 'app.contacts.details.overview';
                vm.route_params = {
                    id: vm.billable.id
                };
                vm.show = true;
                break;
            case 'invoice':
                vm.label = 'Invoice ' + vm.billable.label;
                vm.route = 'app.billing.invoices.details';
                vm.route_params = {
                    id: vm.billable.id
                };
                vm.show = true;
                break;
        }
    }

    function doClickAction() {
        if (!vm.custom_action) {
            window.open($state.href(vm.route, vm.route_params), '_blank');
        } else {
            vm.custom_action();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_links/directives/billable_link/billable_link-directive.js